import clsx from 'clsx';
import React from 'react';

import Highlight from '@components/FeedItems/Highlight';
import { titv_network_index_path } from '@routes';

import Event from '../Event';
import type { TITVNetwork } from '../Network/interfaces';
import ViewAllLink from './ViewAllLink';
import { VIEW_ALL_TEXT } from './constants';

interface TITVMultistreamFeatureNetworkSectionProps {
  isInprogressNetwork?: boolean;
  titvNetwork: TITVNetwork;
}

const TITVMultistreamFeatureNetworkSection = ({
  isInprogressNetwork = false,
  titvNetwork,
}: TITVMultistreamFeatureNetworkSectionProps) => {
  const { description, id, slug, streams = [], title } = titvNetwork;

  if (streams.length === 0) {
    return null;
  }

  const networkPath = titv_network_index_path(slug);

  return (
    <article
      className={clsx(
        'grid grid-cols-1 gap-y-40 sm:grid-cols-2 sm:gap-x-24 lg:grid-cols-3',
        isInprogressNetwork ? 'order-1' : 'order-2'
      )}
    >
      <header>
        <Highlight
          highlight="TITV Presents"
          className="!text-overline-sm"
          customPath={networkPath}
        />
        <h2 className="m-0 mt-10 font-suisse-works text-headline-sm font-normal">{title}</h2>
        <p className="m-0 mt-8 font-suisse-intl text-body-lg font-normal text-primary-black">
          {description}
        </p>
        <ViewAllLink
          className="m-0 mt-12 !inline-block !w-auto text-left font-suisse-intl-mono text-overline-md font-normal text-primary-magenta"
          link={networkPath}
          networkId={id}
          text={VIEW_ALL_TEXT}
        />
      </header>
      {streams.map((stream) => (
        <Event key={stream.id} event={stream} isNetworkSection />
      ))}
    </article>
  );
};

export default TITVMultistreamFeatureNetworkSection;
